import HttpClient from "@/common/boot/HttpClient"

const listarTiposStatus = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.get('/gestao-producao/tipos-status', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const excluirTiposStatus = async ({ dispatch },  payload) => { 
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
    dispatch('listarTiposStatus');
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/gestao-producao/tipos-status/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTipoStatus = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/gestao-producao/tipos-status', payload).then(response => {
    commit('INSERIR_TIPO_STATUS', response.data.data);
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarTipoStatus = ({ commit, state }, payload) => {
  const item = state.items.filter(item => item.id === payload.id);
  if(item.length) {
    commit('INSERIR_TIPO_STATUS_SELECIONADO', ...item);
    return true;
  }

  return false;
}

const atualizarTipoStatus = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  return await HttpClient.put(`/gestao-producao/tipos-status/${payload.id}`, payload).then(response => {
    commit('ATUALIZAR_TIPO_STATUS', response.data.data);
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarTiposStatus,
  excluirTiposStatus,
  salvarTipoStatus,
  recuperarTipoStatus,
  atualizarTipoStatus
}